module.exports = __webpack_public_path__ + "img/assessment-accelerator-intro.0604a367.png";